/* eslint-disable @next/next/no-img-element */
import cx from "classnames";
import { useContext } from "react";
import styles from "./RoundedButton.module.css";
import { ThemeContext } from "./Wizard";

interface RoundedButtonProps {
  crossVariant?: string;
  variant?: string;
  icon: "cross" | "chevron-back";
  onClick: (() => void) | ((v: any) => Promise<void>);
}

export const RoundedButton = ({
  crossVariant = "whiteCross",
  variant = "default",
  icon = "cross",
  onClick,
}: RoundedButtonProps) => {
  const value = useContext(ThemeContext);
  return (
    <div className={cx(styles.roundedButton, styles[icon])} onClick={onClick}>
      <div
        className={cx(
          styles.inner,
          styles[value === 1 ? "lightWhite" : variant]
        )}
      >
        <img
          src={`/decorations/${icon}.svg`}
          alt="Rounded button"
          className={styles[crossVariant]}
        />
      </div>
    </div>
  );
};
